import { render } from "./UUIDGenerator.vue?vue&type=template&id=29d3b899&scoped=true&ts=true"
import script from "./UUIDGenerator.vue?vue&type=script&lang=ts"
export * from "./UUIDGenerator.vue?vue&type=script&lang=ts"

import "./UUIDGenerator.vue?vue&type=style&index=0&id=29d3b899&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29d3b899"]])

export default __exports__